import { T } from "components/util/t";
import { EntryRow } from "./EntryRow";
import { Box } from "@mui/material";

export const EntriesTableContent = ({ entries, showBibs, isAlternates, isTeams, seedIsPosition }) => {
    const showRank = !seedIsPosition && entries.some(entry => entry.rank && !entry.seed);

    return (
        <>
            <thead>
                <tr>
                    <Box component="th" minWidth={theme => theme.spacing(4)} display="flex" justifyContent="center"><T>#</T></Box>
                    <th colSpan={showBibs ? 2 : 1}>{isAlternates ? <T>Cancellations</T> : isTeams ? <T>Team</T> : <T>Athlete</T>}</th>
                    {showRank && <Box component="th" paddingRight={2}><T>Rank</T></Box>}
                </tr>
            </thead>
            <tbody>
                {entries.map((entry, index) =>
                    <EntryRow
                        key={entry.id}
                        index={index}
                        entry={entry}
                        showBib={showBibs}
                        showRank={showRank}
                    />
                )}
            </tbody>
        </>
    );
};
